export default __webpack_public_path__ + "static/media/Background_00114.cc4498ec.png";